

























































































































































































































import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import {
  CustomerModel,
  CustomersApi,
  GroupModel,
  GroupsApi,
  UserModel,
  UsersApi,
} from "../../../apis";
import i18n from "../../../locale";

extend("group", {
  ...required,
  message: (_, values) => i18n.t("message.group_required", values).toString(),
});

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class UserDetailDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop() data?: UserModel;
  fullName: string = "";
  email: string = "";
  avatar: any = null;
  organization: any = null;
  status: any = null;
  selectedGroups: string[] = [];
  selectedCustomer: any = null;
  selectedLocations: any = [];
  groups: GroupModel[] = [];
  groupsClient: GroupModel[] = [];
  groupsECO2: GroupModel[] = [];
  customers: CustomerModel[] = [];
  isAllLocation = false;
  LOCATIONS: any[] = [];
    removeSpecificLocations(id) {
    this.selectedLocations = this.selectedLocations.filter(
      (location) => location !== id
    );
    this.$nextTick(() => {
      this.LOCATIONS = this.LOCATIONS;
    });
  }
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  async onChangeCustomer(option) {
    this.isAllLocation = false;
    this.LOCATIONS = [];
    this.selectedLocations = [];
    if (option && option.value) {
      try {
        new CustomersApi()
          .getActiveLocationsByCustomerId({ id: option.value })
          .then((resp) => {
            this.LOCATIONS = resp.data.data.map((el) => {
              return { value: el.id, text: el.locationName };
            });
          });
      } catch (error) {
        this.$util.showError(error);
      }
    }
  }
  @Watch("value", { deep: true })
  async onShow(val) {
    this.avatar = null;
    if (val) {
      const rs = await new GroupsApi().getGroups();
      this.groups = rs.data.data;
      this.groupsClient = this.groups.filter(g=> g.code === 'CLIENT');
      this.groupsECO2 = this.groups.filter(g=> g.code !== 'CLIENT');


      if (!this.data) return;
      this.email = this.data.email;
      this.fullName = this.data.fullName;
      this.avatar = this.data.photo64;
      this.selectedGroups = this.data.groups.map((item) => item.id);
      this.organization = this.ORGANIZATIONS.find(
        (item) => item.value === this.data.organization
      );
      await new CustomersApi().getCustomers().then(async (response)  => {
        this.customers = response.data.data;
        this.selectedCustomer = this.CUSTOMERS.find(
          (item) => item.value === this.data.customerId
        );
        await this.onChangeCustomer(this.selectedCustomer);
        this.selectedLocations = this.data.accessLocations;
        this.isAllLocation = this.data.isAllLocation;
      });
    } else {
      this.reset();
    }
  }

  get CUSTOMERS() {
    return this.customers.map((val) => ({
      text: val.companyName,
      value: val.id,
    }));
  }

  get ORGANIZATIONS() {
    return [
      { value: "ECO2", text: this.$t("page.user.organization.ECO2") },
      { value: "CLIENT", text: this.$t("page.user.organization.CLIENT") },
    ];
  }
 uploadImage(event){
  const image = event.target.files[0];
  const reader = new FileReader();
  reader.readAsDataURL(image);
  reader.onload = (e) => {
    this.avatar = e.target['result'];
  };
  }
  get STATUS() {
    return [
      { value: "NEW", text: this.$t("page.user.status.NEW") },
      { value: "ACTIVE", text: this.$t("page.user.status.ACTIVE") },
      { value: "INACTIVE", text: this.$t("page.user.status.INACTIVE") },
      { value: "INVITED", text: this.$t("page.user.status.INVITED") },
    ];
  }

  reset() {
    this.selectedGroups = [];
    this.selectedCustomer = null;
    this.status = null;
    this.organization = null;
    this.isAllLocation = false;
    this.LOCATIONS = [];
    this.selectedLocations = [];
  }

  onOrganizationChange() {
      this.selectedGroups = [];
  }

  async onSubmit() {
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    // const loading = this.$loading.show();
    this.$util.showLoading();
    try {
      await new UsersApi().putDoUpdateUser({
        putUserRequest: {
          userId: this.data.id,
          fullName: this.fullName,
          groupIds:this.selectedGroups,
          photo64: this.avatar,
          accessLocations: this.selectedLocations,
          isAllLocation: this.isAllLocation,
          action: "EDIT",
          customerId:
            this.organization && this.organization.value === "CLIENT"
              ? this.selectedCustomer.value
              : undefined,
          // status: this.status ? this.status.value : undefined,
        },
      });
      this.$emit("update:value", false);
      this.$emit("closed");
    } catch (error) {
    } finally {
      // loading.hide();
      this.$util.hideLoading();
    }
  }
}
